import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { Link } from "react-router-dom";
import { Building2, TrendingUp, Users, MapPinned, PieChart as PIcon } from "lucide-react";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useLang } from "@/contexts/LanguageContext";
import { SummaryActions } from "@/components/gov/SummaryActions";
import { DistrictMapSection } from "@/components/gov/DistrictMapSection";

function StatCard({ icon: Icon, label, value, sub, test, to }) {
  const inner = (
    <div className="p-6 rounded-lg border border-slate-200 bg-white flex items-start gap-4 card-hover">
      <div className="w-10 h-10 rounded-md bg-slate-900 grid place-items-center text-white shrink-0"><Icon className="w-5 h-5" /></div>
      <div className="min-w-0 flex-1">
        <div className="text-xs uppercase tracking-widest text-slate-500">{label}</div>
        <div className="mt-1 text-2xl font-bold text-slate-900 brand-heading">{value}</div>
        {sub && <div className="text-xs text-slate-500 mt-0.5">{sub}</div>}
      </div>
    </div>
  );
  return to ? <Link to={to} data-testid={test}>{inner}</Link> : <div data-testid={test}>{inner}</div>;
}

export default function GovDashboard() {
  const [s, setS] = useState({});
  const { t } = useLang();
  useEffect(() => { api.get("/reports/government-summary").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-8" data-testid="gov-dashboard">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div><h1 className="text-2xl sm:text-3xl font-bold text-slate-900 brand-heading">{t("g_title")}</h1><p className="text-slate-600 mt-1 text-sm">{t("g_sub")}</p></div>
        <SummaryActions />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <StatCard icon={Users} label={t("g_msmes")} value={s.registered_msmes ?? "—"} test="gov-msmes" />
        <StatCard icon={TrendingUp} label={t("g_ready")} value={s.credit_ready_msmes ?? "—"} test="gov-ready" />
        <StatCard icon={Building2} label={t("g_demand")} value={formatINR(s.total_credit_demand ?? 0)} test="gov-demand" />
        <StatCard icon={PIcon} label={t("g_apps")} value={s.total_applications ?? "—"} test="gov-apps" />
        <StatCard icon={PIcon} label={t("g_sanct")} value={s.total_sanctioned ?? "—"} test="gov-sanct" />
        <StatCard icon={PIcon} label={t("g_disb")} value={s.total_disbursed ?? "—"} test="gov-disb" />
        <StatCard icon={PIcon} label={t("g_cfree")} value={s.collateral_free_cases ?? "—"} test="gov-cfree" />
        <StatCard icon={Users} label={t("g_women")} value={s.women_owned_cases ?? "—"} test="gov-women" />
        <StatCard icon={MapPinned} label={t("g_districts")} value={s.districts_covered ?? "—"} to="/gov/district-map" test="gov-districts" />
      </div>
      <DistrictMapSection />
      <DisclaimerBanner compact />
    </div>
  );
}
